import React from "react";

const AboutMe = () => {
  return (
    <section
      className="mt-24 font-medium mb-96 leading-8 bg-black bg-opacity-20 py-16 px-4 rounded-lg"
      id="about-me"
    >
      <h2 className="text-cyan-300 text-2xl font-medium text-center mb-12">
        About Me
      </h2>
      <p className="max-w-[850px] mx-auto text-center text-white">
        I am <span className="text-cyan-300">Toukir Ahammed</span>, a{" "}
        <span className="text-cyan-300">Web Developer</span> from Bangladesh. I
        mainly work in
        <span className="text-cyan-300"> React.js</span>, but I can also work
        with the <span className="text-cyan-300">MERN stack</span>. I want to
        become one of the best web developer in the world. That's why I am
        always learning new technologies and building projects.
      </p>
    </section>
  );
};

export default AboutMe;
